import {Component, OnInit, Input, Output, ViewChild, EventEmitter} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';

@Component({
    selector: 'barcode',
    template: require('./barcode.component.html'),
    styles: [require('./barcode.component.css')]
})
@AutoUnsubscribe()

export class BarcodeComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Output() barcodeSaved = new EventEmitter<string>();
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    form: FormGroup;

    constructor(private fb: FormBuilder) { }

    ngOnInit() {
        this.form = this.fb.group({
            barcode: ['', [SharedValidators.customRequired]]
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            this.barcodeSaved.emit(this.checkBarcode(this.form.get('barcode').value));
            this.closeWindow(true);
        }
    }

    checkBarcode(barcode: string): string {
        if (barcode.length < 13) {
            for(let i = barcode.length; i < 13; i++) {
                barcode = '0' + barcode;
            }
        }

        return barcode;
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/barcode.component.ts